<div class="tools-shell" [class.readonly]="isSpectator$ | async">
<div class="tools-readonly-note" *ngIf="isSpectator$ | async">Viewer mode: tools are disabled</div>
<!-- Drawing tools -->
<div class="pxl-section">
  <div class="tools-group-label">Draw</div>
  <div class="tools-grid">
    <button *ngFor="let t of drawTools" class="tool-btn" [class.active]="(activeTool$ | async) === t.type"
      (click)="selectTool(t.type)" [title]="t.label + ' - ' + t.desc + ' [' + t.shortcut + ']'">
      <span class="tool-svg" [innerHTML]="t.svg"></span>
      <span class="tool-label">{{ t.label }}</span>
    </button>
  </div>
</div>

<!-- Shape tools -->
<div class="pxl-section">
  <div class="tools-group-label">Shapes</div>
  <div class="tools-grid">
    <button *ngFor="let t of shapeTools" class="tool-btn" [class.active]="(activeTool$ | async) === t.type"
      (click)="selectTool(t.type)" [title]="t.label">
      <span class="tool-svg" [innerHTML]="t.svg"></span>
      <span class="tool-label">{{ t.label }}</span>
    </button>
  </div>
  <div class="fill-toggle" *ngIf="isShapeTool$ | async">
    <button class="toggle-opt" [class.active]="(shapeFill$ | async) === 'outline'" (click)="setShapeFill('outline')">Outline</button>
    <button class="toggle-opt" [class.active]="(shapeFill$ | async) === 'filled'"  (click)="setShapeFill('filled')">Filled</button>
  </div>
  <!-- Exact size inputs for active shape -->
  <div class="shape-exact-panel" *ngIf="isShapeTool$ | async">
    <div class="shape-exact-label">Dimensions</div>
    <!-- W × H: rect, line, triangle -->
    <div class="shape-exact-row" *ngIf="['rect','line','triangle'].includes((activeTool$ | async)!)">
      <label>W</label><input type="number" [(ngModel)]="exactShapeW" min="1" max="256">
      <label>H</label><input type="number" [(ngModel)]="exactShapeH" min="1" max="256">
    </div>
    <!-- Circle: radius -->
    <div class="shape-exact-row single" *ngIf="(activeTool$ | async) === 'circle'">
      <label>R</label><input type="number" [(ngModel)]="exactShapeR" min="1" max="128">
    </div>
    <!-- Ellipse: Rx, Ry -->
    <div class="shape-exact-row" *ngIf="(activeTool$ | async) === 'ellipse'">
      <label>Rx</label><input type="number" [(ngModel)]="exactShapeW" min="1" max="128">
      <label>Ry</label><input type="number" [(ngModel)]="exactShapeH" min="1" max="128">
    </div>
    <button class="shape-place-btn" (click)="placeExactShape()">
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
      Place at center
    </button>
  </div>
</div>

<!-- Brush -->
<div class="pxl-section">
  <div class="tools-group-label">Brush Size</div>
  <div class="brush-row">
    <button *ngFor="let s of brushSizes" class="brush-btn" [class.active]="(brushSize$ | async) === s"
      (click)="setBrushSize(s)" [title]="s + 'px'">
      <div class="brush-dot" [style.width.px]="s*2+2" [style.height.px]="s*2+2"></div>
    </button>
    <span class="brush-val">{{ brushSize$ | async }}px <span class="shortcut-hint">[  ]</span></span>
  </div>
</div>

<!-- Symmetry -->
<div class="pxl-section">
  <div class="tools-group-label">Symmetry</div>
  <div class="sym-grid">
    <button *ngFor="let sym of symmetryModes" class="sym-btn" [class.active]="(symmetry$ | async) === sym.value"
      (click)="setSymmetry(sym.value)" [title]="sym.label">
      <span class="sym-icon" [innerHTML]="sym.svg"></span>
      <span class="sym-label">{{ sym.label }}</span>
    </button>
  </div>
</div>

<!-- Color -->
<div class="pxl-section">
  <div class="tools-group-label">Color</div>
  <div class="color-row">
    <div class="color-swatch-wrap">
      <div class="color-swatch-big" [style.background]="activeColor$ | async"></div>
      <input type="color" class="color-picker-overlay" [value]="activeColor$ | async" (input)="onColorInput($event)" title="Pick color">
    </div>
    <span class="color-hex">{{ activeColor$ | async }}</span>
  </div>
</div>

<!-- Palette -->
<div class="pxl-section">
  <div class="tools-group-label">Palette</div>
  <div class="palette-grid">
    <button *ngFor="let c of (paletteColors$ | async)" class="swatch"
      [class.active]="(activeColor$ | async) === c" [style.background]="c" [title]="c" (click)="selectColor(c)">
    </button>
  </div>
</div>

<!-- Recent -->
<div class="pxl-section" *ngIf="(recentColors$ | async)?.length">
  <div class="tools-group-label">Recent</div>
  <div class="palette-grid">
    <button *ngFor="let c of (recentColors$ | async)" class="swatch"
      [class.active]="(activeColor$ | async) === c" [style.background]="c" [title]="c" (click)="selectColor(c)">
    </button>
  </div>
</div>
</div>
